function transformValues(_values) {
    const values = Object.assign({}, _values);
    if(values.enemyNameColor.toLowerCase() === "yellow"){
        values.enemyRank = 1;
    } else if(values.enemyNameColor.toLowerCase() === "white"){
        values.enemyRank = 2;
    } else if(values.enemyNameColor.toLowerCase() === "red"){
        values.enemyRank = 3;
    } else if(values.enemyNameColor.toLowerCase() === "purple"){
        values.enemyRank = 4;
    }

    if(values.bestiaryLevel <= 3){
        values.bestiaryMulti = 1;
    } else if(values.bestiaryLevel === 4){
        values.bestiaryMulti = 1.5
    } else if(values.bestiaryLevel === 5){
        values.bestiaryMulti = 2
    } else if(values.bestiaryLevel >= 6){
        values.bestiaryMulti = 3
    }

    if(!values.enemyMulti){
        values.enemyMulti=1;
    }

    if(!values.enemyNameColor){
        values.enemyRank=1;
    }

    if(!values.secondsToKill){
        values.secondsToKill=0.1;
    }
    if(!values.areaEnemyAmount){
        values.areaEnemyAmount=1;
    }

    return values;
}

function chipsPerHourToArray(chips) {
    var array = [];
    for (var count = 0; count < 6; count++) {
        array[count] = chips * (count + 1);
    }

    return array;
}

export function calculateRates(values) {
    // I want to make a function that will determine the optimal ammount of
    // spawn/drop/epic/rate rate
    values = transformValues(values);

    var enemyRankMulti = (0.25 + 0.25 * values.enemyRank + values.enemyLevel * 2 / 9001)
    var rareRealDropRate = values.dropRate * 10 * enemyRankMulti * values.bestiaryMulti * values.enemyMulti;
    var epicRealDropRate = values.dropRate * 20 * enemyRankMulti * values.bestiaryMulti * values.enemyMulti;

    let rareChance = 0;
    let epicChance = 0;

    if(values.IAMastered && values.worstMoon){
        rareChance = Math.min((5 + 0.95 * values.areaRareRate) * (values.rareRate / 100), 100);
        epicChance = Math.min((0.5 + 0.995 * values.areaEpicRateWM) * (values.epicRate / 100), 100);
    } else if(values.IAMastered) {
        rareChance = Math.min((5 + 0.95 * values.areaRareRate) * (values.rareRate / 100), 100);
        epicChance = Math.min((0.5 + 0.995 * values.areaEpicRate) * (values.epicRate / 100), 100);
    } else if(values.worstMoon) {
        rareChance = Math.min(values.areaRareRate * (values.rareRate / 100), 100);
        epicChance = Math.min(values.areaEpicRateWM * (values.epicRate / 100), 100);
    } else {
        rareChance = Math.min(values.areaRareRate * (values.rareRate / 100), 100);
        epicChance = Math.min(values.areaEpicRate * (values.epicRate / 100), 100);
    }

    var rareIADropRate = rareRealDropRate / 10 * (values.areaIADropRate / 100);
    var epicIADropRate = epicRealDropRate / 10 * (values.areaIADropRate / 100);

    console.log("IA drop rate from a rare monster: " + rareIADropRate.toFixed(2) + "%");
    console.log("IA drop rate from an epic monster: " + epicIADropRate.toFixed(2) + "%");
    console.log(rareChance.toFixed(2) + "% chance to encounter a rare monster");
    console.log(epicChance.toFixed(2) + "% chance to encounter an epic monster");

    var realSpawnRate = (values.areaSpawnRate / (values.spawnRate / 100) + values.secondsToKill) / (values.enemySpawnChance / 100);

    console.log(rareRealDropRate.toFixed(2) + "% real drop rate from a rare monster");
    console.log(epicRealDropRate.toFixed(2) + "% real drop rate from an epic monster");

    // sets epic chance and rare chance, making sure not to divide by zero
    if(epicChance === 100){
        var rareSpawnRate = 0;
    } else {
        var rareSpawnRate = realSpawnRate / ((rareChance / 100) * (100 - epicChance) / 100)
    }
    var epicSpawnRate = realSpawnRate / (epicChance / 100);

    // sets base chip DRs from rare and epic monsters
    var baseRareChipDropRate = rareIADropRate / 10
    var baseEpicChipDropRate = epicIADropRate / 10

    if(values.hardcore){
        baseRareChipDropRate *= 2;
        baseEpicChipDropRate *= 2;
    }
    if(values.worstMoon){
        baseRareChipDropRate *= 3;
        baseEpicChipDropRate *= 3;
    }
    if(values.gemOfGoodLuck){
        baseRareChipDropRate *= 1.5;
        baseEpicChipDropRate *= 1.5;
    }
    if(values.apocalypse){
        baseRareChipDropRate *= 2;
        baseEpicChipDropRate *= 2;
    }

    baseRareChipDropRate = Math.min(baseRareChipDropRate, 100);
    baseEpicChipDropRate = Math.min(baseEpicChipDropRate, 100);

    var rareGreenChipDropRate = 0;
    var epicRedChipDropRate = 0;
    var epicGreenChipDropRate = 0;

    if(values.gemOfGoodLuck && values.bestiaryLevel >= 7){
        epicRedChipDropRate = baseEpicChipDropRate / 10 / 40;
    }else if(values.bestiaryLevel >= 7){
        epicRedChipDropRate = baseEpicChipDropRate / 10 / 1000;
    }

    if(values.gemOfGoodLuck && values.bestiaryLevel >= 5){
        epicGreenChipDropRate = (baseEpicChipDropRate / 10 / 4) - (epicRedChipDropRate / 2);
    }else if(values.bestiaryLevel >= 5){
        epicGreenChipDropRate = (baseEpicChipDropRate / 10 / 20) - (epicRedChipDropRate / 2);
    }

    var epicYellowChipDropRate = (baseEpicChipDropRate / 10) - (epicGreenChipDropRate / 2) - (epicRedChipDropRate / 3);

    if(values.gemOfGoodLuck && values.bestiaryLevel >= 6){
        rareGreenChipDropRate = baseRareChipDropRate / 20 / 12500;
    } else if(values.bestiaryLevel >= 6){
        rareGreenChipDropRate = baseRareChipDropRate / 20 / 50000
    }

    var rareYellowChipDropRate = (baseRareChipDropRate / 20 / 10) - (rareGreenChipDropRate / 2);

    console.log(epicRedChipDropRate, epicGreenChipDropRate, epicYellowChipDropRate, baseEpicChipDropRate, "epic RGY chip DRs & base epic chip DR");
    console.log(rareGreenChipDropRate, rareYellowChipDropRate, baseRareChipDropRate, "rare GY chip DRs & rare epic chip DR");

    // sets chips per hour of each color, making sure not to divide by 0
    if(rareSpawnRate === 0){
        var greenChipsPerHour = ((epicGreenChipDropRate / 100) / epicSpawnRate) * 60 * 60
        var yellowChipsPerHour = ((epicYellowChipDropRate / 100) / epicSpawnRate) * 60 * 60
    } else {
        var greenChipsPerHour = (((epicGreenChipDropRate / 100) / epicSpawnRate) + ((rareGreenChipDropRate / 100) / rareSpawnRate)) * 60 * 60
        var yellowChipsPerHour = (((epicYellowChipDropRate / 100) / epicSpawnRate) + ((rareYellowChipDropRate / 100) / rareSpawnRate)) * 60 * 60
    }
    var redChipsPerHour = (epicRedChipDropRate / 100) / epicSpawnRate * 60 * 60;

    console.log(redChipsPerHour, greenChipsPerHour, yellowChipsPerHour, "chips/hour");





    //console.log("You have a " + rareChipDropRate + "% chance to get a chip drop from a rare monster")
    //console.log("You have a " + epicChipDropRate + "% chance to get a chip drop from an epic monster")

    if(rareSpawnRate === 0){
        console.log("You can only encounter epic monsters");
    } else {
        console.log("It takes " + rareSpawnRate.toFixed(2) + " seconds to encounter a rare monster");
    }
    console.log("It takes " + epicSpawnRate.toFixed(2) + " seconds to encounter an epic monster");

    console.log("-----------------------------------------------------------------------------------------------------------");

    return {
        yellowChips: chipsPerHourToArray(yellowChipsPerHour),
        greenChips: chipsPerHourToArray(greenChipsPerHour),
        redChips: chipsPerHourToArray(redChipsPerHour)
    };
}


// WEBPACK FOOTER //
// ./src/calculation.js